import React from "react";
import NewsletterSignup from "./Newsletter";

const Footer = () => {
    return (
        <footer className="bg-black text-white font-light">
            {/* Newsletter Section -  */}
            <div className="border-b border-gray-800">
                <div className="max-w-7xl mx-auto px-6 py-14">
                    <div className="text-center max-w-3xl mx-auto">
                        <p className="text-xs tracking-[0.3em] uppercase text-gray-400 mb-8">Stay Informed</p>
                        <p className="text-lg font-light leading-relaxed text-gray-300 mb-12">
                            Exclusive insights, industry intelligence, and transformative strategies 
                            curated for forward-thinking professionals.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
                            <NewsletterSignup />
                        </div>
                        <p className="text-gray-400 text-xs tracking-wide mt-4">
                            No spam, unsubscribe at any time
                        </p>
                    </div>
                </div>
            </div>

            {/* Main Footer Content */}
            <div className="max-w-7xl mx-auto px-6 py-20">
                <div className="grid lg:grid-cols-6 gap-12 mb-16">
                    {/* Brand Section */}
                    <div className="lg:col-span-2">
                        <div className="mb-8">
                            {/* Logo placeholder - you can replace with your actual logo */}
                            <div className="text-2xl font-thin tracking-[0.2em] mb-6">FROST & GREY</div>
                            <div className="w-12 h-px bg-gradient-to-r from-white to-transparent mb-8"></div>
                        </div>
                        <p className="text-gray-300 leading-relaxed font-light text-sm mb-8">
                            Empowering organizations and professionals with practical AI training and 
                            implementation solutions for growth and innovation in the modern era.
                        </p>
                        
                        {/* Social Links - Minimalist Style */}
                        <div className="flex gap-6">
                            <a href="https://web.facebook.com/profile.php?id=100092843855928" target="_blank" rel="noreferrer" 
                                  className="text-gray-400 hover:text-white transition-colors">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                                </svg>
                            </a>
                            <a href="https://www.instagram.com/_frostandgrey/" target="_blank" rel="noreferrer"
                                  className="text-gray-400 hover:text-white transition-colors">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                                </svg>
                            </a>
                            <a href="https://www.linkedin.com/company/frost-grey" target="_blank" rel="noreferrer"
                                  className="text-gray-400 hover:text-white transition-colors">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Navigation Columns */}
                    <div>
                        <h4 className="text-xs tracking-[0.3em] uppercase text-gray-400 mb-8">Programs</h4>
                        <div className="w-6 h-px bg-gray-700 mb-8"></div>
                        <ul className="space-y-4">
                            <li className="text-gray-300 hover:text-white transition-colors font-light text-sm">AI for Teams</li>
                            <li className="text-gray-300 hover:text-white transition-colors font-light text-sm">Leadership Workshops</li>
                            <li className="text-gray-300 hover:text-white transition-colors font-light text-sm">Implementation Labs</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-xs tracking-[0.3em] uppercase text-gray-400 mb-8">Solutions</h4>
                        <div className="w-6 h-px bg-gray-700 mb-8"></div>
                        <ul className="space-y-4">
                            <li className="text-gray-300 hover:text-white transition-colors font-light text-sm">Custom AI Solutions</li>
                            <li className="text-gray-300 hover:text-white transition-colors font-light text-sm">Enterprise Integration</li>
                            <li className="text-gray-300 hover:text-white transition-colors font-light text-sm">Success Stories</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-xs tracking-[0.3em] uppercase text-gray-400 mb-8">Resources</h4>
                        <div className="w-6 h-px bg-gray-700 mb-8"></div>
                        <ul className="space-y-4">
                            <li><a href="/blog" className="text-gray-300 hover:text-white transition-colors font-light text-sm">Blog</a></li>
                            <li><a href="/privacy-policy" className="text-gray-300 hover:text-white transition-colors font-light text-sm">Privacy Policy</a></li>
                            <li><a href="/terms-of-service" className="text-gray-300 hover:text-white transition-colors font-light text-sm">Terms of Service</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-xs tracking-[0.3em] uppercase text-gray-400 mb-8">Connect</h4>
                        <div className="w-6 h-px bg-gray-700 mb-8"></div>
                        <ul className="space-y-4">
                            <li><a href="mailto:info@frostgrey.com" className="text-gray-300 hover:text-white transition-colors font-light text-sm">hello@frostgrey.com</a></li>
                            <li><a href="mailto:hello@frostgrey.com" className="text-gray-300 hover:text-white transition-colors font-light text-sm">corporate@frostgrey.com</a></li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className="border-t border-gray-800 pt-12">
                    <div className="flex flex-col lg:flex-row justify-between items-center gap-8">
                        <div className="flex flex-col sm:flex-row items-center gap-8 text-xs tracking-[0.2em] text-gray-400">
                            <span>© {new Date().getFullYear()} FROST & GREY</span>
                            <div className="w-px h-4 bg-gray-700 hidden sm:block"></div>
                            <span className="uppercase">All Rights Reserved</span>
                        </div>

                        <div className="flex items-center gap-8 text-xs tracking-[0.2em] text-gray-400">
                            <a href="/privacy-policy" className="hover:text-white transition-colors uppercase">Privacy</a>
                            <div className="w-px h-4 bg-gray-700"></div>
                            <a href="/terms-of-service" className="hover:text-white transition-colors uppercase">Terms</a>
                            <div className="w-px h-4 bg-gray-700"></div>
                            <span className="uppercase">Made with Intelligence</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
